import * as XLSX from 'xlsx';
import { ListNfseInput, ListNfseOutput } from 'services/interfaces/nfse';
import { listNfse } from 'services/nfse';
import { R$ } from 'shared/helpers/currency';
import { NFSE_REPORT_STATUS_LABELS } from '../types/nfse.types';
import { formatDate, formatDocument } from './csvValidation';

const EXPORT_PAGE_SIZE = 500;

export async function fetchAllNfseRecords(
  baseParams: ListNfseInput,
  onProgress?: (fetched: number, total: number) => void,
): Promise<ListNfseOutput[]> {
  const allRecords: ListNfseOutput[] = [];
  let offset = 0;
  let total = Infinity;

  while (offset < total) {
    const response = await listNfse({
      ...baseParams,
      limit: EXPORT_PAGE_SIZE,
      offset,
    });

    const { data, total: responseTotal } = response.data;
    total = responseTotal;
    allRecords.push(...data);
    offset += EXPORT_PAGE_SIZE;

    onProgress?.(allRecords.length, total);
  }

  return allRecords;
}

function getPrice(item: ListNfseOutput): string {
  if (item.orderId && item.orderPrice) {
    return R$(item.orderPrice) ?? 'R$ 0,00';
  }
  if (item.batchRecordId && item.batchRecordPrice) {
    return R$(item.batchRecordPrice) ?? 'R$ 0,00';
  }
  return 'R$ 0,00';
}

function getStatusLabel(status: string): string {
  return (
    NFSE_REPORT_STATUS_LABELS[
      status as keyof typeof NFSE_REPORT_STATUS_LABELS
    ] || status
  );
}

export function exportNfseXlsx(
  rows: ListNfseOutput[],
  filename = 'relatorio-dps.xlsx',
) {
  const data = rows.map((row) => ({
    'DPS ID': row.id,
    'Cobrança ID': row.orderId ?? row.batchRecordId ?? '-',
    Valor: getPrice(row),
    Documento: row.customerDocument
      ? formatDocument(row.customerDocument)
      : '-',
    Status: getStatusLabel(row.status),
    'Cód. Serviço': row.nationalTaxCode,
    NBS: row.nbsCode ?? '-',
    'Chave de Acesso': row.accessKey ?? '-',
    'Nº NFS-e Nacional': row.nationalNfseNumber ?? '-',
    Erro: row.errorMessage
      ? `${row.errorCode ?? ''}: ${row.errorMessage}`
      : '-',
    'Atualizado em': formatDate(row.updatedAt),
  }));

  const ws = XLSX.utils.json_to_sheet(data);

  ws['!cols'] = [
    { wch: 10 },
    { wch: 14 },
    { wch: 14 },
    { wch: 20 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
    { wch: 50 },
    { wch: 20 },
    { wch: 40 },
    { wch: 18 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Relatório DPS');
  XLSX.writeFile(wb, filename);
}
